<div class="h-full overflow-auto w-96 md:w-128 bg-lightblue">
  <div class="context-title" *ngIf="(artist$ | async) as artist">
    {{ artist.name }}
  </div>
    <div class="p-4">
        <context-bar-events></context-bar-events>
        <context-bar-doings></context-bar-doings>
        <context-bar-notes></context-bar-notes>
        <context-bar-tasks></context-bar-tasks>
    </div>
</div>
    <!--
    <div class="rounded mb-4 bg-white p-2 shadow relative" *ngIf="!eventsPopupOpened">
        <div class="text-xl relative">
            Kalender
            <div class="absolute right-0 vertical-center mr-2 text-gray-500">
                <div class="cursor-pointer inline-block mr-2" (click)="toggleEventLiveReload()">
                    <span *ngIf="liveUpdateEvents">
                        <span class="iconify" data-icon="fluent:live-24-regular"></span>
                    </span>
                    <span *ngIf="!liveUpdateEvents">
                        <span class="iconify" data-icon="fluent:live-off-24-regular"></span>
                    </span>
                </div>
                <div class="cursor-pointer inline-block" (click)="openEventsPopup()">
                    <span class="iconify" data-icon="websymbol:popup"></span>
                </div>
            </div>
        </div>
        <div [class.hidden]="!!(selectedCooperation$ | async)">
            <app-mini-calendar  (dateChanged)="dateChanged($event)" [currentMonthEvents]="(cooperationMonthEvents$ | async)" (monthChanged)="monthChanged($event)">
                <div>
                    <div class="text-sm px-3 bg-blue-400 text-white rounded-lg inline-block font-medium mb-2 mt-3">{{ (cooperationEvents$ | async).length }} Termine</div>
                    <div *ngIf="(cooperationEvents$ | async).length == 0">
                        Keine Termine an diesem Tag
                    </div>
                    <app-event (deleted)="removeEvent(event)" [event]="event" *ngFor="let event of (cooperationEvents$ | async)"></app-event>
                </div>
            </app-mini-calendar>
        </div>
        <div [class.hidden]="!(selectedCooperation$ | async)" #eventScrollContainer style="max-height:70vh;overflow: auto;" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onEventScroll()">
            <app-event *ngFor="let event of (cooperationEvents$ | async)" [event]="event" [cooperation]="(selectedCooperation$ | async)"></app-event>
        </div>
        <div *ngIf="(selectedCooperation$ | async) != null" matRipple (click)="addEvent()" class="py-2 mt-2 cursor-pointer text-center px-3 bg-blue-600 text-white shadow rounded-sm">
            Termin hinzufügen
        </div>
        <div *ngIf="(selectedCooperation$ | async) == null" matRipple (click)="addCooperation()" class="py-2 mt-2 cursor-pointer text-center px-3 bg-blue-600 text-white shadow rounded-sm">
            Kooperation hinzufügen
        </div>
        <div class="text-right mt-2" *ngIf="(selectedCooperation$ | async) != null">
            <a *ngIf="!showAllEvents" (click)="showAllEvents = true; reload()" class="text-primary text-sm hover:underline cursor-pointer">Alle Termine anzeigen</a>
            <a *ngIf="showAllEvents" (click)="showAllEvents = false; reload()" class="text-primary text-sm hover:underline cursor-pointer">Offene Termine anzeigen</a>
        </div>
    </div>

  <div class="rounded mb-4 bg-white p-2 shadow relative" *ngIf="!eventsPopupOpened">
    <div class="text-xl relative">
      Termine
      <div class="absolute right-0 vertical-center mr-2 text-gray-500">
        <div class="cursor-pointer inline-block mr-2" (click)="toggleEventLiveReload()">
          <span *ngIf="liveUpdateEvents">
            <span class="iconify" data-icon="fluent:live-24-regular"></span>
          </span>
          <span *ngIf="!liveUpdateEvents">
            <span class="iconify" data-icon="fluent:live-off-24-regular"></span>
          </span>
        </div>
        <div class="cursor-pointer inline-block" (click)="openEventsPopup()">
          <span class="iconify" data-icon="websymbol:popup"></span>
        </div>
      </div>
    </div>
    <div *ngIf="(cooperationEvents$ | async).length == 0" class="mb-2 text-center">
      <div class="text-4xl">
        <span class="iconify inline-block" data-icon="twemoji:partying-face"></span>
      </div>

      <em>Alles erledigt!</em>
    </div>
    <div #eventScrollContainer style="max-height:50vh;overflow: auto;" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onEventScroll()">
      <app-event (deleted)="removeEvent(event)" [event]="event" *ngFor="let event of (cooperationEvents$ | async)"></app-event>
    </div>
    <div *ngIf="(selectedCooperation$ | async) != null" matRipple (click)="addEvent()" class="py-2 mt-2 cursor-pointer text-center px-3 bg-blue-600 text-white shadow rounded-sm">
      Termin hinzufügen
    </div>
    <div *ngIf="(selectedCooperation$ | async) == null" matRipple (click)="addCooperation()" class="py-2 mt-2 cursor-pointer text-center px-3 bg-blue-600 text-white shadow rounded-sm">
      Kooperation hinzufügen
    </div>
    <div class="text-right mt-2" *ngIf="(selectedCooperation$ | async) != null">
      <a *ngIf="!showAllEvents" (click)="showAllEvents = true; reload()" class="text-primary text-sm hover:underline cursor-pointer">Alle Termine anzeigen</a>
      <a *ngIf="showAllEvents" (click)="showAllEvents = false; reload()" class="text-primary text-sm hover:underline cursor-pointer">Offene Termine anzeigen</a>
    </div>
  </div>

  <div class="rounded mb-4 bg-white p-2 shadow relative" *ngIf="!doingsPopupOpened">
    <div class="text-lg relative">
      <div class="doing-subtype-dropdown">
        <select [(ngModel)]="selectedDoingSubtype" (ngModelChange)="doingSubtypeUpdated($event)">
          <option value="all">Alle</option>
          <option value="management">Management</option>
          <option value="event">Event</option>
        </select>
      </div>
      Doings ({{ overdueDoingCount }} / {{ doingCount + overdueDoingCount }})


      <div class="absolute right-0 vertical-center mr-2 text-gray-500">
        <div class="cursor-pointer inline-block mr-2" (click)="toggleDoingLiveReload()">
          <span *ngIf="liveUpdateDoings">
            <span class="iconify" data-icon="fluent:live-24-regular"></span>
          </span>
          <span *ngIf="!liveUpdateDoings">
            <span class="iconify" data-icon="fluent:live-off-24-regular"></span>
          </span>
        </div>
        <div class="cursor-pointer inline-block" (click)="openDoingsPopup()">
          <span class="iconify" data-icon="websymbol:popup"></span>
        </div>
      </div>
    </div>
    <input [value]="doingQuery$ | async" class="styled" placeholder="Suche..." type="text" ngModel (ngModelChange)="doingQueryChanged($event)" />

    <div class="flex flex-wrap my-1">
      <div class="w-1/2">
         <mat-checkbox ngModel (ngModelChange)="changeArchivedDoings($event)" [checked]="(archivedDoings$ | async)">Archivierte Doings anzeigen</mat-checkbox>
      </div>
      <div class="w-1/2" *ngIf="(doingSort$ | async) as sort">
        <div class="text-right pr-6 relative text-blue-400 cursor-pointer" [matMenuTriggerFor]="doingSortActions">
          <span *ngIf="sort.name == 'created' && sort.order == 'desc'">Neu nach alt</span>
          <span *ngIf="sort.name == 'created' && sort.order == 'asc'">Alt nach neu</span>
          <div class="absolute right-0 vertical-center text-2xs">
            <span class="iconify" data-icon="fa:chevron-down"></span>
          </div>
        </div>
        <mat-menu #doingSortActions>
          <div (click)="doingSort('created', 'desc')" class="outline-none cursor-pointer" mat-menu-item>
            <span>Neu nach alt</span>
          </div>
          <div (click)="doingSort('created', 'asc')" class="outline-none cursor-pointer" mat-menu-item>
            <span>Alt nach neu</span>
          </div>
        </mat-menu>
      </div>
    </div>

    <div class="text-sm px-3 bg-orange-500 text-white rounded-lg inline-block font-medium mb-2">Überfällig</div>
    <div class="p-2 rounded bg-gray-200">
      <div *ngIf="(overdueDoings$ | async).length == 0">
        <em>Keine überfälligen Doings vorhanden</em>
      </div>

      <div #overdueDoingScrollContainer style="max-height:40vh;overflow: auto;" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onOverdueDoingScroll()">
        <app-doing (followUpAdded)="moveOverdueToNormal(doing)" [doing]="doing" *ngFor="let doing of (overdueDoings$ | async); trackBy: identify"></app-doing>
      </div>
    </div>

    <div class="text-sm px-3 bg-blue-400 text-white rounded-lg inline-block font-medium mb-2 mt-3">Doings</div>
    <div class="p-2 rounded bg-gray-200">
      <div *ngIf="(doings$ | async).length == 0">
        <em>Keine aktiven Doings vorhanden</em>
      </div>

      <div #doingScrollContainer style="max-height:40vh;overflow: auto;" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onDoingScroll()">
        <app-doing [doing]="doing" *ngFor="let doing of (doings$ | async); trackBy: identify"></app-doing>
      </div>
    </div>




    <app-note-form [userSearchEnabled]="artist == null" (submit)="addDoing($event)" [customerSearchEnabled]="true" placeholderText="Doing hinzufügen"></app-note-form>
    <div [routerLink]="['/doings', 'archive']" class="text-sm mt-3 text-primary cursor-pointer hover:underline">
      Doing-Archiv
    </div>
  </div>

  <div class="rounded mb-4 bg-white p-2 shadow relative" *ngIf="!tasksPopupOpened">
    <div class="text-xl relative">
      Aufgaben
      <div class="absolute right-0 vertical-center mr-2 text-gray-500">
        <div class="cursor-pointer" (click)="openTasksPopup()">
          <span class="iconify" data-icon="websymbol:popup"></span>
        </div>
      </div>
    </div>
    <div *ngIf="(tasks$ | async).length == 0" class="text-center mb-2">
      <div class="text-4xl">
        <span class="iconify inline-block" data-icon="twemoji:partying-face"></span>
      </div>

      <em>Alles erledigt!</em>
    </div>

    <app-task (deleted)="onTaskDeleted(task)" [task]="task" *ngFor="let task of (tasks$ | async)"></app-task>
    <app-note-form [userSearchEnabled]="artist == null" placeholderText="Aufgabe hinzufügen" [cooperationSearchEnabled]="(selectedCooperation$ | async) == null" (submit)="addTask($event)"></app-note-form>
  </div>

  <div class="rounded mb-4 bg-white p-2 shadow relative" *ngIf="!notesPopupOpened">
    <div class="text-xl relative">
      Notizen ({{ notesCount }})
      <div class="absolute right-0 vertical-center mr-2 text-gray-500">
        <div class="cursor-pointer" (click)="openNotesPopup()">
          <span class="iconify" data-icon="websymbol:popup"></span>
        </div>
      </div>
    </div>
    <div *ngIf="(notes$ | async).length == 0">
      <em>Keine Notizen vorhanden</em>
    </div>
    <div #noteScrollContainer style="max-height:50vh;overflow: auto;" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onNoteScroll()">
      <div *ngFor="let note of (notes$ | async); trackBy: identify" class="mb-2 min-h-12 p-2 bg-white shadow rounded-sm">
        <div class="font-bold text-blue-400" *ngIf="note.markedUser">
          @{{ note.markedUser.displayName ? note.markedUser.displayName : note.markedUser.username }}
        </div>
        {{ note.text }}
        <div (click)="deleteNote(note)" class="text-xs text-red-300 hover:text-red-500 cursor-pointer">Entfernen</div>
      </div>
    </div>

    <app-note-form [userSearchEnabled]="artist == null" [cooperationSearchEnabled]="(selectedCooperation$ | async) == null" (submit)="addNote($event)"></app-note-form>
  </div>


</div>-->
